import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import Input, { INPUT_VALUE_TYPES } from "../BaseControls/Input";
import { controlPropTypes } from "../formhelpers";
import alertAndRefocusBuilder
    from "lib/common/descriptorcontrols/BaseControls/utils/alertAndRefocusBuilder";

export default class Spinner extends React.Component {
    render() {
        return (
            <ControlTemplate {...this.props} className="integer-field" >
                <Input
                    {...this.props}
                    valueType={INPUT_VALUE_TYPES.INTEGER}
                    onIllegal={alertAndRefocusBuilder(this.props)}
                />
            </ControlTemplate>
        );
    }
}

Spinner.propTypes = controlPropTypes();



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/IntegerField/spinner.js